import { createTheme } from "@mantine/core";
import {
  BRAND_PALETTES,
  DEFAULT_BRAND_PALETTE,
  type BrandPaletteKey,
} from "./brandPalettes";

export function createEvolysTheme(paletteKey: BrandPaletteKey) {
  const palette = BRAND_PALETTES[paletteKey];

  return createTheme({
    primaryColor: "brand",
    primaryShade: { light: 6, dark: 6 },
    autoContrast: true,
    colors: {
      brand: palette.colors,
    },
    fontFamily:
      '"Source Sans 3", Aptos, Inter, system-ui, -apple-system, sans-serif',
    headings: {
      fontFamily:
        'Montserrat, "Aptos Display", Aptos, Inter, system-ui, -apple-system, sans-serif',
      fontWeight: "700",
    },
    defaultRadius: "md",
    components: {
      Button: {
        defaultProps: { radius: "md" },
      },
      Card: {
        defaultProps: { radius: "md", withBorder: true },
      },
      TextInput: {
        defaultProps: { radius: "md" },
      },
      Select: {
        defaultProps: { radius: "md" },
      },
      NumberInput: {
        defaultProps: { radius: "md" },
      },
      Textarea: {
        defaultProps: { radius: "md" },
      },
      Modal: {
        defaultProps: { radius: "md", centered: true },
      },
      Table: {
        defaultProps: { striped: "odd", highlightOnHover: true },
      },
      Badge: {
        defaultProps: { radius: "sm" },
      },
      Paper: {
        defaultProps: { radius: "md", withBorder: true },
      },
      Pagination: {
        defaultProps: { radius: "md" },
      },
    },
  });
}

export const evolysTheme = createEvolysTheme(DEFAULT_BRAND_PALETTE);
